<template>
	<div>
		<div class="loading-progress-btn" v-show="isLoading"></div>

		<div class="loading-progress-logo" v-show="isLogoLoading">
			<div class="loader-box">
				<span class="dot"></span>
				<span class="dot"></span>
				<span class="dot"></span>
				<span class="dot"></span>
				<span class="dot"></span>
			</div>
		</div>

		<div v-if="isComplete">{{completeText}}</div>
	</div>
</template>
<script>
	export default{
		name:'Loading',
		props:{
			isLoading:{
				type:Boolean,
				default:false
			},
			isLogoLoading:{
				type:Boolean,
				default:false
			},
			isComplete:{
				type:Boolean,
				default:false
			},
			completeText:{
				type:String,
				default:'没有更多数据了'
			}
		}

	}
</script>
<style scoped>


body{margin:0;height:100vh;display:flex;align-items:center;justify-content:center;background:#f5f5f5}

.loader-box{display:flex;gap:8px}

.dot{
  width:15px;
  height:15px;
  border-radius:50%;
  animation:wave 1.2s cubic-bezier(.45,.05,.55,.95) infinite alternate both;
}

/* 每个点单独色值（色块渐变） */
.dot:nth-child(1){ background:#23d3ee; animation-delay:calc(0.12s * 0); }
.dot:nth-child(2){ background:#00c6ff; animation-delay:calc(0.12s * 1); }
.dot:nth-child(3){ background:#0099ff; animation-delay:calc(0.12s * 2); }
.dot:nth-child(4){ background:#0277ff; animation-delay:calc(0.12s * 3); }
.dot:nth-child(5){ background:#0956c8; animation-delay:calc(0.12s * 4); }

@keyframes wave{
  0%   { transform:scale(.3) translateY(0);   opacity:.4; }
  50%  { transform:scale(1.2) translateY(-10px); opacity:1; }
  100% { transform:scale(.3) translateY(0);   opacity:.4; }
}
</style>



// WEBPACK FOOTER //
// src/common/cmpnt/Loading/Loading.vue